import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { renderToStaticMarkup } from 'react-dom/server';
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";

import { boardsActions } from '../../../store/boards';

class Details extends React.Component {

    componentDidMount() {
        this.props.getBoard(this.props.location.pathname.split('/')[4]);
    }

    componentDidUpdate() {
        this.props.getBoard(this.props.location.pathname.split('/')[4]);
    }

    fileFilter(files) {
        const attachments = files.filter(file => file.type === "attachments");
        if (attachments.length !== 0) return attachments[0].fileName;
    }

    render() {
        if (!this.props.board) return null;

        document.querySelector("main").scrollIntoView();

        const board = this.props.board.board;

        // https://www.npmjs.com/package/html-react-parser
        // https://codesandbox.io/s/2y8wqoqoy?from-embed
        function transform(node, index) {
            if (node.type === "tag" && node.name === "img") {
                //console.log(node.attribs);
                node.attribs.style = "max-width: 100%; height: auto;";
                return convertNodeToElement(node, index, transform);
            }
        }

        const options = {
            decodeEntities: true,
            transform
        }

        const html = ReactHtmlParser(board.content, options);
        board.content = renderToStaticMarkup(html);
        //console.log(renderToStaticMarkup(html));

        return (
            <div className="container g-py-30">
                <div className="row">
                    <div className="col-lg-9 g-pr-30--lg">
                        <h3>{board.title}</h3>
                        <ul className="list-inline g-overflow-hidden g-mb-0">
                            <li id="timestamp" className="list-inline-item g-mx-4">{moment(board.time).format("YYYY-MM-DD hh:mm")}</li>
                            <li className="list-inline-item g-mx-4">|</li>
                            <li className="list-inline-item g-mx-4"><span className="icon-mouse" style={{ fontSize: "11px" }}></span> {board.hit}</li>
                        </ul>

                        {/* 첨부파일 */}
                        <ul className="list-inline g-overflow-hidden">
                            {board.files.map(function (item, index) {
                                if (item.type === 'attachments') {
                                    return (
                                        <li key={index} className="list-inline-item g-mx-4"><Link to={`/api/files/attachments/${item.name}/${item.fileName}`} target="_blank">{item.fileName}</Link></li>
                                    )
                                }
                                return null;
                            })}
                        </ul>

                        {/* 콘텐츠 */}
                        <div id="content" className="g-mt-50">
                            {board.content && <div dangerouslySetInnerHTML={{ __html: board.content }} />}
                        </div>

                        {/* 이전글 다음글 */}
                        <nav className="text-center g-py-30" aria-label="Page Navigation">
                            <ul className="list-inline mb-0">
                                {this.props.board.previewId &&
                                    <li className="list-inline-item float-sm-left">
                                        <Link to={`/details/${this.props.board.category}/${this.props.board.subCategory}/${this.props.board.previewId}`} className="u-pagination-v1__item u-pagination-v1-4 g-brd-gray-light-v3 g-brd-primary--hover g-pa-7-16" aria-label="Previous">
                                            <span aria-hidden="true"><i className="fa fa-angle-left g-pr-5"></i>이전글</span>
                                        </Link>
                                    </li>
                                }
                                <li className="list-inline-item">
                                    <Link to={`/${board.category}/${board.subCategory}`} className="u-pagination-v1__item u-pagination-v1-4 g-brd-gray-light-v3 g-brd-primary--hover g-pa-7-16" aria-label="List">
                                        <span aria-hidden="true"><i className="icon-grid"></i></span>
                                    </Link>
                                </li>
                                {this.props.board.nextId &&
                                    <li className="list-inline-item float-sm-right">
                                    <Link to={`/details/${this.props.board.category}/${this.props.board.subCategory}/${this.props.board.nextId}`} className="u-pagination-v1__item u-pagination-v1-4 g-brd-gray-light-v3 g-brd-primary--hover  g-pa-7-16" aria-label="Next">
                                            <span aria-hidden="true">다음글<i className="fa fa-angle-right g-pl-5"></i></span>
                                        </Link>
                                    </li>
                                }
                            </ul>
                        </nav>
                    </div>

                    {/* 사이드바 */}
                    <div className="col-lg-3 g-brd-left--lg g-brd-gray-light-v4 g-mb-80 g-hidden-md-down">
                        <div className="g-pl-20--lg">
                            <div id="stickyblock-start">
                                <div className="js-sticky-block g-sticky-block--lg" data-start-point="#stickyblock-start" data-end-point="#stickyblock-end" data-has-sticky-header="true">
                                    {this.props.board.queries &&
                                        <div className="g-mb-30">
                                            <h2 className="h5 g-color-black g-font-weight-600 mb-3">관련글 보기</h2>
                                            <div className="d-inline-block g-width-50 g-height-2 g-bg-black mb-3"></div>
                                            <ul className="list-unstyled g-font-size-13 mb-20">
                                                {this.props.board.queries.map((item, index) => {
                                                    const linkTo = `/details/${item.category}/${item.subCategory}/${item.boardId}`;
                                                    return (
                                                        <li key={index}>
                                                            <p><Link to={linkTo} className="g-color-gray-dark-v4 g-color-primary--hover g-text-underline--none--hover">{item.title.substring(0, 42)}</Link></p>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    }

                                    {this.props.board.queries && <hr className="g-brd-gray-light-v4 g-mt-0 g-mb-40" />}

                                    {this.props.board.boards &&
                                        <div className="g-mb-30">
                                            <h2 className="h5 g-color-black g-font-weight-600 mb-3">활동내 최신글 보기</h2>
                                            <div className="d-inline-block g-width-50 g-height-2 g-bg-black mb-3"></div>
                                            <ul className="list-unstyled g-font-size-13 mb-20">
                                                {this.props.board.boards.map((item, index) => {
                                                    const linkTo = `/details/${item.category}/${item.subCategory}/${item.boardId}`;
                                                    return (
                                                        <li key={index}>
                                                            <p><Link to={linkTo} className="g-color-gray-dark-v4 g-color-primary--hover g-text-underline--none--hover">{item.title.substring(0, 42)}</Link></p>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Details));


// WEBPACK FOOTER //
// ./src/pages/front/board/details.js